import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from '../../components_root/loadingimg.jsx';
import Loading_items from "../../components_root/loading_items.jsx";
import logo_default from "../../assets/logo_default.jpg"; 
import Loading from "../../components_root/loading.jsx"; 
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx"; 
export const seoFallback = {
  title: "aooz | Amazing Products & Tools",
  description: "Check out products and services on aooz.",
  keywords: "aooz products, services, tools",
  url: "https://aooz.in",
  image: "https://aooz.in/assets/logo.png",
};

export default function Upload_dock() {
  const { Toastshow } = Toast();
  const navigate = useNavigate();
  const [IsLoading2, setIsLoading2] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [brandnamedata, setBrandnameData] = useState([]);
  const [titlemete, setTitlemete] = useState("");
  const [keywordsmete, setKeywordsmete] = useState("");
  const [products_new_data, setProducts_new_data] = useState([]);
  const [vouchersdata, setVouchersdata] = useState([]);
  const [companydata, setCompanydata] = useState([]);
   const servicetablename = "accountingfinancedb";
  // ✅ Fetch unique categories (brandname → corrected to category)
  // useEffect(() => {
  //   const fetchBrandname = async () => {
  //     setIsLoading2(true);
  //     try {
  //       const q = query(collection(db, "products"), where("status", "==", true));
  //       const snapshot = await getDocs(q);

  //       if (snapshot.empty) {
  //         setBrandnameData([]);
  //         setIsLoading2(false);
  //         return;
  //       }

  //       const brandMap = new Map();

  //       snapshot.docs.forEach((doc) => {
  //         const data = doc.data();
  //         if (!data.brandname) return;

  //         // Each brand keeps its latest product info
  //         brandMap.set(data.brandname, {
  //           brandname: data.brandname,
  //           title: data.title || "",
  //           price: data.price || "",
  //           thumbnail: data.thumbnail || "",
  //           uid: doc.id,
  //           createdAt: data.createdAt || null,
  //         });
  //       });

  //       // Convert map to array
  //       const brandList = Array.from(brandMap.values());
  //       setBrandnameData(brandList);
  //     } catch (err) {
  //       console.error("Error fetching brand names:", err);
  //     } finally {
  //       setIsLoading2(false);
  //     }
  //   };

  //   fetchBrandname();
  // }, []); 

  // ✅ Fetch products grouped by category
 
useEffect(() => {
    const select_company_uid = Cookies.get("select_company_uid");
    setIsLoading2(true);

    if (!select_company_uid) {
        console.error("No company selected");
        setIsLoading2(false);
        return;
    }

    // Correct path:
    const productQuery = query(
        collection(db, servicetablename, select_company_uid, "vouchers"),orderBy("indexnumber", "desc"),
    );

    const unsubscribe = onSnapshot(
        productQuery,
        (snapshot) => {
            const vouchers = snapshot.docs.map((docSnap) => ({
                id: docSnap.id,
                ...docSnap.data(),
            }));
         setVouchersdata(vouchers);
        setIsLoading2(false);
        },
        (error) => {
            console.error("Error fetching vouchers:", error);
            setIsLoading2(false);
        }
    );

    return () => unsubscribe();
}, []);



  const meta = {
    title: titlemete || seoFallback.title,
    description: seoFallback.description,
    keywords: keywordsmete || seoFallback.keywords,
    image: seoFallback.image,
    url: `https://aooz.in`,
  };


  return (
    <div  >

      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:url" content={meta.url} />
      </Helmet>
      {/* <div >
        <HomeSlideshow slideshow_filedata={review_slideshow_filedata}
          banner_default={banner_default}
          navigate={navigate} />
      </div> */}
      {/* brandname */}
      <div className="container_roots">

        <div className="container_roots m-top m-bottom container_size">

          <br />
          {/* New Products */}
          <div className="ui-grid-home-items">
            {IsLoading2 ? (
              <></>
            ) : vouchersdata.length === 0 ? (
              <div>data not find</div>
            ) : (
              vouchersdata.map((row) => (
                <div className="ui-items items-back items-back shadow hover rounded cursor" onClick={() => navigate("/" + row.voucherid)} key={row.uid}>
                  <img src={row.logo_url || logo_default} alt={row.voucher} className="brand-thumbnail" />
                  <div >
                    <div className="flex p-11 b-bottom">
                      <table>
                        <tr>
                          <td>
                            <span className="text-h2 bold">Amount</span>
                          </td>
                          <td className="text-r">
                            <div className="text-h1 bold">  <span className="text-off text-h1">₹</span>{row.amount || ""}<span className="text-off text-h2">/-</span></div>
                          </td>
                        </tr>
                      </table>



                    </div>
                    <div className="p-11 ">

                      <div className="text-h1 fcap bold">{row.voucher}</div>
                      <div className="text-h3 fcap m-b">{row.description?.substring(0, 200)}</div>
                      {row.child?.dealname && (
                        <div><span className="red text-h3 items-back rounded-sm">{row.child.dealname}</span></div>
                      )}
                    </div>

                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <br />
      </div>

    </div>
  );
}
